<template>
	<div class="ui segment">
		<div class="ui top attached label">
			<i class="map icon"> Location: </i>
			</div>
			<div><b>Station name:</b> {{getI18n(featureOfInterest.samplingFeature.name,"en")}}</div>
			<div v-if="isPoint">
				<div>Longitude : {{featureOfInterest.samplingFeature.geometry.coordinates[0]}}</div>
				<div>Latitude : {{featureOfInterest.samplingFeature.geometry.coordinates[1]}}</div>
				<div v-if="featureOfInterest.samplingFeature.geometry.coordinates[2] != undefined">Altitude : {{featureOfInterest.samplingFeature.geometry.coordinates[2]}}</div>
			</div>
			<div v-else>
				<div>
						<div>{{maxLong}}</div>
						<div><i class="arrow up icon"></i></div>
					</div>
					<div>{{minLat}}  <i class="arrow left icon"></i><i class="arrow right icon"> {{maxLat}}</i></div>
					<div>
						<div><i class="arrow down icon"></i></div>
						<div>{{maxLong}}</div>
					</div>
			</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isPoint: false,
			minLong: null,
			maxLon:  null,
			minLat: null,
			maxAlt: null,
			minAlt: null,
			maxAlt: null
		}
	},
  props: ["featureOfInterest"],
  methods: {
    /**
     * Getter to get the value according the the internationalisation
     */
    getI18n(el, lang) {
      let tmp = el.find(element => element.lang === lang);
      return tmp.text;
    },
    /**
     * Method to populate component data according to the geometry of the observation
     */
    getLocationCoordinates() {
      if (this.featureOfInterest.samplingFeature.geometry.type !== "Point") {
        let latLngs = [];

        //Recursive method that push all coordinates in LatLngs[]
        getPointRecursively(
          this.featureOfInterest.samplingFeature.geometry.coordinates,
          latLngs
        );

        let longitudes = [];
        let latitudes = [];
        let altitudes = [];
        latLngs.forEach(element => {
          longitudes.push(element[0]);
          latitudes.push(element[1]);
          if (element[2] != null) {
            altitudes.push(element[2]);
          }
        });

        this.minLong = Math.min(...longitudes);
        this.maxLong = Math.max(...longitudes);
        this.minLat = Math.min(...latitudes);
        this.maxLat = Math.max(...latitudes);
        if (altitudes.size !== 0) {
          this.minAlt = Math.min(...altitudes);
          this.maxAlt = Math.max(...altitudes);
        }
      } else {
				this.isPoint = true;
			}
    }
	},
	created() {
		this.getLocationCoordinates();
	}
};
/**
 * Recursive method that push all coordinates in array 
 */
let getPointRecursively = function(coordsArray, latLngs) {
  coordsArray.forEach(element => {
    if (Array.isArray(element)) {
      getPointRecursively(element, latLngs);
    } else {
      latLngs.push(coordsArray);
    }
  });
};
</script>

<style>
</style>
